import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Form } from 'redux-form';
import { HeadingFive, Button, Card } from 'hui/src/styled';
import { CategoryType } from '../types';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import { trackEvent } from '../../../utils/googleAnalytics';
import { fillContainer, buttonAlignment, disabledButton } from './shared/SharedStyles';
import CategorySelect from '../CategorySelect';

const select = formValueSelector('GQWIZARD');
const validate = values => {
  const errors = {};
  if (!values.search_str) {
    errors.search_str = 'Please type or select a category';
  }
  return errors;
};

const CategoryStep = ({
  categories,
  handleSubmit,
  initialCategory,
  onSelectCategory,
  selectedCategory,
  category,
  change
}) => (
  <Form onSubmit={handleSubmit} style={fillContainer}>
    <Card m={0} p={1} center style={fillContainer}>
      <HeadingFive mb={1}>What do you need?</HeadingFive>
      <div style={{ textAlign: 'left' }}>
        <CategorySelect
          categories={categories}
          label={''}
          initialCategory={initialCategory}
          updateField={change}
          selectedCategory={selectedCategory}
          onSelectCategory={option => {
            onSelectCategory(option);
            trackEvent(
              EventCategories.POST_JOB_MODAL,
              EventActions.SELECT_CATEGORY,
              option.label,
              '',
              '',
              false
            );
          }}
        />
      </div>
      <Button
        disabled={!selectedCategory}
        type={'submit'}
        m={0.5}
        block
        style={selectedCategory ? buttonAlignment : disabledButton}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={EventActions.PRESS_NEXT_CATEGORIES_SCREEN}
        data-ga-label={category}
      >
        Next
      </Button>
    </Card>
  </Form>
);

CategoryStep.propTypes = {
  categories: PropTypes.arrayOf(CategoryType),
  handleSubmit: PropTypes.func,
  back: PropTypes.func,
  selectedCategory: CategoryType,
  onSelectCategory: PropTypes.func,
  change: PropTypes.func,
  initialCategory: CategoryType,
  invalid: PropTypes.bool,
  progress: PropTypes.string,
  step: PropTypes.string,
  category: PropTypes.object
};

const ConnectedStep = reduxForm({
  form: 'GQWIZARD',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(CategoryStep);

export default connect(state => ({ category: select(state, 'search_str') }))(ConnectedStep);
